import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_staff/it-operation-core/")({
  beforeLoad: () => {
    throw redirect({ to: "/it-operation-core/packages" });
  },
});
